import { useState } from 'react';
import { arrivalTimes, countries } from '../data';
import BookSteps from './BookSteps';
import StaySummary from './StaySummary';

export default function CheckoutPage({ search, room, user, guest, onBack, onContinue }) {
  const [form, setForm] = useState(() => ({
    first: guest?.first || '',
    last: guest?.last || '',
    email: guest?.email || user || '',
    phone: guest?.phone || '',
    country: guest?.country || 'Tanzania',
    arrival: guest?.arrival || '14:00',
    notes: guest?.notes || '',
  }));

  const submit = (e) => {
    e.preventDefault();
    if (!form.first.trim() || !form.last.trim() || !form.email.trim() || !form.phone.trim()) return;
    onContinue(form);
  };

  const set = (key) => (e) => setForm({ ...form, [key]: e.target.value });

  return (
    <div className="page page-book">
      <div className="wrap">
        <div className="crumbs">
          <button onClick={onBack}>{room.name}</button>
          <span>›</span>
          <span>Guest details</span>
        </div>
        <BookSteps current={0} />
        <header className="book-head">
          <p className="stay-bar-kicker">Step 1 of 3</p>
          <h1 className="results-title">Guest information</h1>
          <p className="book-lead">Tell us who is staying so we can have the room ready.</p>
        </header>
        <div className="checkout-layout">
          <form className="checkout-form book-panel" onSubmit={submit}>
            <section className="book-section">
              <h2>About you</h2>
              <div className="field-grid">
                <div>
                  <label className="field-label" htmlFor="first-name">First name</label>
                  <input id="first-name" autoComplete="given-name" value={form.first} onChange={set('first')} required />
                </div>
                <div>
                  <label className="field-label" htmlFor="last-name">Last name</label>
                  <input id="last-name" autoComplete="family-name" value={form.last} onChange={set('last')} required />
                </div>
              </div>
              <label className="field-label" htmlFor="guest-email">Email</label>
              <input id="guest-email" type="email" autoComplete="email" value={form.email} onChange={set('email')} required />
              <label className="field-label" htmlFor="guest-phone">Phone</label>
              <input id="guest-phone" type="tel" autoComplete="tel" value={form.phone} onChange={set('phone')} required />
            </section>
            <section className="book-section">
              <h2>Stay preferences</h2>
              <div className="field-grid">
                <div>
                  <label className="field-label" htmlFor="guest-country">Country / region</label>
                  <select id="guest-country" value={form.country} onChange={set('country')}>
                    {countries.map((c) => <option key={c} value={c}>{c}</option>)}
                  </select>
                </div>
                <div>
                  <label className="field-label" htmlFor="guest-arrival">Estimated arrival</label>
                  <select id="guest-arrival" value={form.arrival} onChange={set('arrival')}>
                    {arrivalTimes.map((t) => <option key={t} value={t}>{t}</option>)}
                  </select>
                </div>
              </div>
              <label className="field-label" htmlFor="guest-notes">Special requests</label>
              <textarea id="guest-notes" rows="3" value={form.notes} onChange={set('notes')} placeholder="Early check-in, extra pillows, quiet room…" />
            </section>
            <button className="see-btn book-submit" type="submit">Continue to payment</button>
          </form>
          <StaySummary search={search} room={room} />
        </div>
      </div>
    </div>
  );
}
